export default "__VITE_ASSET__D1$tFW_F__"